<div class="overlay-root col">
  <section class="overlay-content col">
    <div class="content-wrap">
      <div class="be-card row ai-c">
        <div class="card-main col">
          <div class="heading">
            {{ (data?.from || 'Logistics International') + ' \u2192 ' + (data?.to || 'Welisara Limited') }}
          </div>
          <div class="meta col">
            <div class="meta-line">Location Type : {{ data?.locationType || 'Partner' }}</div>
            <div class="meta-line">Activity Type : {{ data?.activityType || 'CARGO-LOADING-FTL' }}</div>
          </div>

          <div class="badge row ai-c">
            {{ data?.jobId || 'HMTDE-250625-00001 - 1' }}
          </div>

          <div class="divider"></div>

          <div class="stats row">
            <div class="stat col">
              <div class="label">Requested Time of Arrival</div>
              <div class="value">{{ data?.requestedArrival || '2025-06-25 01:20:PM' }}</div>
            </div>
            <div class="stat col">
              <div class="label">Requested Time of Departure</div>
              <div class="value">{{ data?.requestedDeparture || '2025-06-25 01:20:PM' }}</div>
            </div>
            <div class="stat col">
              <div class="label">Estimated Duration</div>
              <div class="value">{{ (data?.estimatedDurationMin || 60) + ' min' }}</div>
            </div>
          </div>
        </div>

        <button mat-icon-button type="button" class="go-btn" aria-label="Proceed">
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>


